import { Quote } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, stagger, fadeUp } from "../../lib/motion";
import { TESTIMONIALS } from "../../data/site";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-24 lg:py-32 bg-[#0d1424]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="mb-14 max-w-2xl">
        <Reveal><p className="overline mb-4">In their words</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[var(--text)] leading-[1.02]">
            Families who <span className="text-gold italic">sleep better.</span>
          </h2>
        </Reveal>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid grid-cols-1 md:grid-cols-3 gap-5"
      >
        {TESTIMONIALS.map((t, i) => (
          <motion.blockquote
            key={i}
            variants={fadeUp}
            data-testid={`testimonial-${i}`}
            className="rounded-2xl bg-[#111827] border border-[#2A3441] p-8 flex flex-col"
          >
            <Quote className="text-gold mb-6" size={28} />
            <p className="font-display text-lg lg:text-xl text-white/85 leading-relaxed italic flex-1">
              &ldquo;{t.quote}&rdquo;
            </p>
            <footer className="mt-8 pt-6 border-t border-white/10">
              <div className="text-[var(--text)] font-medium">{t.name}</div>
              <div className="text-xs uppercase tracking-widest text-white/45 mt-1">{t.role}</div>
            </footer>
          </motion.blockquote>
        ))}
      </motion.div>
    </div>
  </section>
);
